// 供销商小店商品列表
<template>
  <div class="display-goods-list">
    <div class="sticky">
      <Search
        ref="search"
        @search="search"
        :total="pagination.total"
      />
      <GoodsFilter
        ref="goodsFilter"
        @search="search"
      />
      <div class="table-btns-wrap">
        <el-checkbox
          v-model="allSelected"
          class="mgr12"
        >
          本页全选
        </el-checkbox>
        <el-button
          type="primary"
          @click="()=> $emit('login')"
          :disabled="!selectedGoods.length"
          plain
        >
          组合铺货
        </el-button>
        <el-button
          type="primary"
          @click="()=> $emit('login')"
          disabled
          plain
        >
          批量铺货
        </el-button>
        <!-- <el-button
          type="primary"
          disabled
          plain
        >
          创建套件铺货
        </el-button> -->
        <el-button
          type="primary"
          @click="()=> $emit('login')"
          plain
          :disabled="!selectedGoods.length"
        >
          加入分销商品
        </el-button>
      </div>
      <Sorter
        ref="sorter" @search="search"
      />
    </div>
    <GoodsList
      ref="goodList"
      :list="list"
      @join="()=> $emit('login')"
      @shelves="()=> $emit('login')"
      @updateSelectedGoods="updateSelectedGoods"
      :loading="loading"
      :isInCooperation="isInCooperation"
    />
    <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <!-- 商品资料编辑 -->
    <EditDialog ref="editDialog" @search="formUpdated => formUpdated ? fetchList() : null" />
    <BulkShelvesDialog
      :openEdit="openEditDialog"
      :closeEdit="closeEditDialog"
      @search="fetchList"
      ref="bulkShelvesDialog"
    />
    <BulkShelvesResults
      ref="bulkShelvesResults"
      @search="search"
      :publishSpeedResult="publishResult"
      :percentage="publishPercenttage"
      pageId="d_display"
    />
    <!-- 组合铺货 -->
    <GroupBulkShelvesDialog
      @search="search"
      ref="groupBulkShelvesDialog"
      mode="distributor"
      from="supplierShop"
      :supplierCompanyId="supplierCompanyId"
    />

    <!-- 批量导入商品资料弹窗 -->
    <ImportSupplierItem ref="importSupplierItem" />
    <!-- 导入 -->
    <DownloadProgress ref="progressDialog" :isJoin="isJoin">
      <template slot="title">
        <span class="down-title">{{ this.progressTitle }}</span>
      </template>
    </DownloadProgress>
    <!-- 导入结果信息弹窗 -->
    <DownloadResult
      :visible.sync="resultVisible"
      :resultData="resultData"
      @search="search"
    >
      <template v-slot:title>
        <span class="down-title">商品导入完成</span>
      </template>
    </DownloadResult>
  </div>
</template>

<script>
import SupplierInfo from "./components/supplierInfo.vue";
import Search from "./components/search.vue";
import Sorter from "./components/Sorter.vue";
import GoodsFilter from "./components/GoodsFilter.vue";
import GoodsList from "./components/GoodsList.vue";
import BulkShelvesDialog from "@/components/prod/center/dialogs/bulkShelvesDialog.vue";
import BulkShelvesResults from "@/components/prod/center/dialogs/bulkShelvesResults.vue";
import GroupBulkShelvesDialog from "@/components/prod/center/dialogs/GroupBulkShelvesDialog/index.vue";
import ImportSupplierItem from "@/components/prod/center/dialogs/importSupplierItem.vue";
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import DownloadProgress from "@/components/prod/center/components/DownloadProgress.vue";
import DownloadResult from "@/components/prod/center/components/DownloadResult.vue";
import { shareSupplierGoodsList } from "@servers/prod/center";
import { importSupplierItem } from "@api/distributor";
import { mapGetters, mapActions } from "vuex";
import { cloneDeep, get } from "lodash";
import { getCooperationRelation, supplierPromotionShopCompanyInfo } from '@/api/distributor';

export default {
  props: ['supplierCompanyId'],
  provide: {
    publishEntrance: 2,
  },
  components: {
    SupplierInfo,
    Search,
    Sorter,
    GoodsFilter,
    GoodsList,
    BulkShelvesDialog,
    GroupBulkShelvesDialog,
    ImportSupplierItem,
    DownloadProgress,
    DownloadResult,
    EditDialog,
    BulkShelvesResults,
  },
  data() {
    return {
      loading: false,
      pagination: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      list: [],
      progressTitle: "商品正在导入中...",
      taskTypeEnum: "",
      resultVisible: false,
      resultData: {
        successNum: 0,
        totalNum: 0,
      }, // 结果
      isJoin: false,
      // 选中的商品数组
      selectedGoods: [],
      // 本页全选
      allSelected: false,
      // 是否合作中关系 0 - 未建立合作关系 1-待审核 11-待审核 12-待授权 2-已生效 3-已作废 4-已拒绝
      isInCooperation: 0,
      supplierInfo: {},
    };
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "speedResult",
      "speedPercentage",
      "routerPrefix",
      "displayRePublishData",
    ]),
    publishResult() {
      return this.speedResult("d_display");
    },
    publishPercenttage() {
      return this.speedPercentage("d_display");
    },
  },
  watch: {
    supplierCompanyId(newVal, oldValue) {
      if (!newVal) {
        return;
      }
      this.pagination.pageNo = 1;
      this.fetchList();
      this.getIsInCooperation();
      this.getSupplierInfo(newVal);
      let selectedGoods = this.$refs.goodList.method_getSelectedArr();
      this.selectedGoods = selectedGoods;
    },
    allSelected(newValue, oldValue) {
      // 本页全选
      let list = cloneDeep(this.list);
      list.forEach(item => {
        item.ischecked = newValue;
      });
      this.list = list;
      this.selectedGoods = newValue ? cloneDeep(list) : [];
      this.$refs.goodList.selectedArr = newValue ? cloneDeep(list) : [];
    }
  },
  methods: {
    ...mapActions(["clearDisplayRePublishRowData"]),
    search() {
      this.pagination.pageNo = 1;
      this.fetchList();
    },
    // 更新选中商品数组
    updateSelectedGoods(arr) {
      this.selectedGoods = arr;
      // 是否全选本页
      this.allSelected = arr.length === this.list.length;
    },

    async getSupplierInfo(id) {
      let res = await supplierPromotionShopCompanyInfo({
        supplierCompanyId: id,
      });
      let detail = get(res, 'data', {}) || {};
      this.supplierInfo = detail;
    },

    // 是否合作中的供销商
    async getIsInCooperation() {
      const res = await getCooperationRelation({
        distributorCompanyId: this.userInfo.companyId,
        supplierCompanyId: this.supplierCompanyId,
      });
      // 0-未建立合作关系、1-待审核、2-已合作、3-已停止、4-已拒绝
      this.isInCooperation = get(res, 'data', 0);
    },

    topBtnsClick() {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog('shelves', true);
        return;
      }
      // 一些需要判断是否需要先选择商品
      const selectedRows = this.$refs.goodList.method_getSelectedArr();
      if (!selectedRows.length) return this.$message.warning("请先选择商品");
      // 取铺货平台的交集
      const _canPublishPlatforms = selectedRows.map(row => {
        return row.canPublishPlatform;
      });
      const canPublishPlatform = _canPublishPlatforms.reduce((data, item) => {
        return data.filter(i => {
          return item.some(j => {
            return i === j;
          });
        });
      });
      if (canPublishPlatform.length) {
        if (canPublishPlatform.length === 1 && canPublishPlatform[0] === "tm") {
          this.$message.warning("天猫平台暂不支持批量铺货操作");
        } else {
          this.$refs.bulkShelvesDialog.method_open("multi", selectedRows, {
            isDistributor: true,
            canPublishPlatform,
            publishType: "PUBLISH_ITEM",
            publishEntrance: 2,
          });
        }
      } else {
        const isFalg = selectedRows.some(row => {
          return row.canPublishPlatform.length;
        });
        if (selectedRows.length === 1) {
          return this.$message.warning("暂无可铺货平台");
        } else {
          if (isFalg) {
            return this.$message.warning(
              "商品可铺货平台不一致，仅支持同平台铺货"
            );
          } else {
            return this.$message.warning("暂无可铺货平台");
          }
        }
      }
    },

    // 组合铺货
    groupBulkShelves() {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog('group');
        return;
      }
      const selectedRows = this.$refs.goodList.method_getSelectedArr();
      selectedRows.forEach(item => {
        item.mainImagesTrim = item.mainImages;
      });
      if (selectedRows.length < 2) {
        return this.$message.warning("单个商品不支持组合铺货！");
      } else if (selectedRows.length > 50) {
        return this.$message.warning("组合铺货商品数量不能超过50个！");
      }
      this.$refs.groupBulkShelvesDialog.method_open(selectedRows);
    },

    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.allSelected = false;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.allSelected = false;
      this.fetchList();
    },
    openEditDialog(params, extraParams) {
      console.log("params", params);
      console.log("extraParams", extraParams);
      this.$refs.editDialog.method_open(params, extraParams);
    },
    closeEditDialog() {
      this.$refs.editDialog.method_close();
    },

    // 批量加分销
    batchAddDistribution() {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog('join', true);
        return;
      }
      // 当前选中的商品
      let selectedGoods = this.$refs.goodList.method_getSelectedArr();
      this.progressTitle = `${selectedGoods.length}款商品正在加入中...`;
      let supplierItemList = selectedGoods.map(row => ({
        supplierCompanyId: row.companyId,
        baseItemId: row.baseItemId,
      }))
      this.taskTypeEnum = "JOIN_DISTRIBUTOR_ITEM";
      const params = {
        supplierItemList,
        syncType: 1,
        inputType: 5,
      };
      this.fetch_importSupplierItem(params);
    },

    /**
     * 展示是否合作弹窗
     * isBatch - 是否批量 0：否，1：是
     */
    showCooperationDialog(type, isBatch) {
      let arr = [3, 1, 2, 3, 3];
      arr[11] = 1;
      arr[12] = 12;
      let num = isBatch ? 0 : arr[this.isInCooperation];
      let key = `${type}${isBatch ? 'Batch' : ''}${num}`;
      if (type === 'group') {
        key = 'group';
      }
      console.log(key);
      // 去审核
      const goAudit = () => {
        this.$router.push({
          path: '/distributor/supplier/mine',
          query: {
            searchContent: this.supplierInfo.companyName,
          },
        });
      }

      const handleRelationBind = async () => {
        const { companyId: distributorCompanyId } = this.userInfo;
        let supplierCompanyId = get(this.$route, 'query.supplierId', '');
        let res = await relationBind({
          distributorCompanyId,
          needAudit: 1,
          supplierCompanyId,
        })
        if (res.result === 1) {
          this.$message.success('已提交申请')
        }
      }
      const messageMap = {
        // 加入分销商品（待审核）
        join1: {
          message: '您还没同供销商建立供分销关系，需合作后才能加分销商品到您的分销商品库，请先审核该供销商的合作申请',
          confirmButtonText: '去审核',
          cancelButtonText: '稍后再说',
          onConfirm: goAudit,
        },
        // 加入分销商品（待授权）
        join12: {
          message: '您已提交合作申请，需合作后才能加分销商品到您的分销商品库，请耐心等待哦~',
          confirmButtonText: '我知道了',
          showCancelButton: false,
        },
        // 加入分销商品（已拒绝、已停止）
        join3: {
          message: '您还没同供销商建立供分销关系，需合作后才能加分销商品到您的分销商品库，请先提交合作申请',
          confirmButtonText: '立即申请',
          cancelButtonText: '稍后再说',
          onConfirm: handleRelationBind,
        },
        // 一键铺货（待审核）
        shelves1: {
          message: '您还没同供销商建立供分销关系，需合作后才能把商品一键铺货到您的店铺，请先审核该供销商的合作申请',
          confirmButtonText: '去审核',
          cancelButtonText: '稍后再说',
          onConfirm: goAudit,
        },
        // 一键铺货（待授权）
        shelves12: {
          message: '您已提交合作申请，需合作后才能把商品一键铺货到您的店铺，请耐心等待哦~',
          confirmButtonText: '我知道了',
          showCancelButton: false,
        },
        // 一键铺货（已拒绝、已停止）
        shelves3: {
          message: '您还没和供销商建立供分销关系，需合作后才能把商品一键铺货到您的店铺，请先提交合作申请',
          confirmButtonText: '去审核',
          cancelButtonText: '稍后再说',
          onConfirm: goAudit,
        },
        // 批量加入分销（未合作）
        joinBatch0: {
          message: '您还没同供销商建立供分销关系，无法批量加入分销商品，需向商家申请并建立合作关系后再来操作~',
          confirmButtonText: '取消加入分销',
          showCancelButton: false,
        },
        // 批量铺货（未合作）
        shelvesBatch0: {
          message: '您还没同供销商建立供分销关系，若要全部铺货到指定平台，需向商家申请并建立合作关系后再来操作~',
          confirmButtonText: '取消批量铺货',
          showCancelButton: false,
        },

        // 组合铺货（未合作）
        group: {
          message: '您还没同供销商建立供分销关系，若要全部铺货到指定平台，需向商家申请并建立合作关系后再来操作~',
          confirmButtonText: '取消组合铺货',
          showCancelButton: false,
        },
      }
      const confirmConfig = {
        title: '提示',
        message: '您还没和供销商建立供分销关系，需合作后才能把商品一键铺货到您的店铺，请先提交合作申请',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      };
      this.$confirm(confirmConfig.title, messageMap[key]?.message, {
        ...confirmConfig,
        ...messageMap[key],
        callback: (action, instance) => {
          if (action === 'confirm') {
            if (messageMap[key]?.onConfirm) {
              messageMap[key].onConfirm();
            }
          } else {
            console.log('弹窗关闭');
          }
        }
      })
    },

    // 加入分销，一键铺货
    rowClick(type, row) {
      if (this.isInCooperation !== 2) {
        this.showCooperationDialog(type);
        return;
      }
      switch (type) {
        case "join": // 加入分销
          if (row.isDistributor) {
            this.$message.warning('该商品已在分分销商品中');
            return;
          }
          this.progressTitle = "商品正在加入中...";
          this.taskTypeEnum = "JOIN_DISTRIBUTOR_ITEM";
          const params = {
            supplierItemList: [
              {
                supplierCompanyId: row.companyId,
                baseItemId: row.baseItemId,
              },
            ],
            syncType: 1,
            inputType: 5,
          };
          this.fetch_importSupplierItem(params);
          break;
        case "shelves": // 铺货
          if (row.canPublishPlatform.length && row.canPublishPlatform.length === 1 && row.canPublishPlatform[0] === "tm") {
            this.$message.warning("需将商品导入商品资料并前往商品资料才可进行天猫铺货");
          } else {
            this.$refs.bulkShelvesDialog.method_open("single", [row], {
              isDistributor: true,
              canPublishPlatform: row.canPublishPlatform,
              publishType: "PUBLISH_ITEM",
              publishEntrance: 2,
            });
          }
          break;
        default:
      }
    },

    async fetchList() {
      this.$refs.goodList.methods_clearSelectedArr();
      this.allSelected = false;
      const { pageNo, pageSize } = this.pagination;
      const searchParams = this.$refs.search.method_getSearchForm();
      const sortParams = this.$refs.sorter.getSortParams();
      const filterParams = this.$refs.goodsFilter.getFilterParams();
      this.loading = true;
      const _params = {
        companyId: this.supplierCompanyId,
        pageNo,
        pageSize,
        ...searchParams,
        ...sortParams,
        ...filterParams,
      };
      const res = await shareSupplierGoodsList(_params);
      this.loading = false;
      if (res) {
        const { records, total } = res;
        const _records = records.map(item => {
          return {
            ...item,
            ischecked: false,
          };
        });
        this.list = _records;
        this.pagination.total = total;
        //  重新铺货
        if (
          this.displayRePublishData &&
          this.displayRePublishData.publishEntrance == 2
        ) {
          const canPublishPlatform =
            this.displayRePublishData.platform.split(",");
          if (canPublishPlatform.length) {
            if (
              canPublishPlatform.length === 1 &&
              canPublishPlatform[0] === "tm"
            ) {
              this.$message.warning(
                "需将商品导入商品资料并前往商品资料才可进行天猫铺货"
              );
            } else {
              this.$refs.bulkShelvesDialog.method_open(
                "single",
                [
                  {
                    ...this.displayRePublishData,
                    canPublishPlatform,
                    companyId: this.displayRePublishData.extendVal2,
                  },
                ],
                {
                  isDistributor: true,
                  canPublishPlatform,
                  publishType: "PUBLISH_ITEM",
                  publishEntrance: 2,
                }
              );
            }
          } else {
            this.$message.warning("暂无可铺货平台");
          }
        }
      }
    },

    // 加入分销商品
    async fetch_importSupplierItem(params, replaceType) {
      const _params = {
        ...params,
        replaceType: replaceType,
      };
      const res = await importSupplierItem(_params);
      if (res.result === 1) {
        // 轮询查看同步任务结果
        // await this.fetch_queryJobResult()
        this.isJoin = this.taskTypeEnum == "JOIN_DISTRIBUTOR_ITEM" ? false : true;
        this.$refs.progressDialog.showDialog();
        this.$refs.progressDialog.calculation_progress(_params.length);
        this.$refs.progressDialog.queryJobResult(
          { taskTypeEnum: this.taskTypeEnum },
          res => {
            if (res.finished) {
              if (this.taskTypeEnum == "JOIN_DISTRIBUTOR_ITEM") {
                if (res.errorMsg) {
                  this.$message.error(res.errorMsg);
                } else {
                  this.$message.success("已成功添加分销商品");
                  this.fetchList();
                }
              } else {
                this.resultData = {...res.result};
                this.resultVisible = true;
              }
            }
          }
        );
      }
    },
  },
  mounted() {
    this.fetchList();
    this.getIsInCooperation();
    this.getSupplierInfo(this.supplierCompanyId);
    let selectedGoods = this.$refs.goodList.method_getSelectedArr();
    this.selectedGoods = selectedGoods;
  },
  beforeDestroy() {
    this.clearDisplayRePublishRowData();
  },
  deactivated() {
    this.$refs.progressDialog.handleClose();
  },
};
</script>

<style lang="scss" scoped>
.display-goods-list {
  text-align: left;
  box-sizing: border-box;
}
.down-title {
  font-size: 18px;
  padding-bottom: 20px;
  display: inline-block;
  font-weight: 800;
}
.table-btns-wrap {
  margin-bottom: 16px;
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.sticky {
  position: sticky;
  top: 0;
  padding: 12px;
  background-color: #fff;
  z-index: 99;
  box-shadow: 0px 10px 20px 0px rgba(126, 125, 125, 0.2);
}
</style>
